<template>
  <div class="scale_input">
    <div class="area_box" ref="areabox" :style="{'width':width+'px','height':height+'px'}">
<!--      <textarea ref="area" @focus="focusText" @blur="blurText" v-html="value"></textarea>-->
      <textarea readonly ref="area" @blur="blurText" v-html="value"></textarea>
    </div>
  </div>
</template>
<script>

export default {
  components: {},
  props: {
    type:String,
    width:Number,
    height:Number,
    value:String
  },
  computed: {},
  watch: {
    value:function (val){
      if(val != null || val !== '' ){
        setTimeout(()=>{
          this.focusText();
          this.blurText();
        },100)

      }
    }
  },
  data() {
    return {
      scaleVal: 1
    }
  },
  mounted() {

  },
  methods: {
    focusText(){
      let $el = $(this.$refs.area);
      let $boxel = $(this.$refs.areabox);
      let scaleVal = Number($el.css("transform").split(',')[3]);
      let boxClientWidth = $boxel[0].clientWidth;
      let boxClientHeight = $boxel[0].clientHeight;
      console.log(scaleVal);
      if(scaleVal === 1){
        $el.css({
          "height":"100%",
          "width": "100%",
          "text-align":(this.type === 'l_c' || this.type === 'l_t') ? 'left' : 'center'
        })
        $boxel.css({
          "display":"block"
        })
      }else {
        if(this.type === 'l_c' || this.type === 'c_c'){
          $el.css({
            "height": boxClientHeight/(this.scaleVal),
            "top": -(boxClientHeight/(this.scaleVal))*(1-this.scaleVal)/2,
            "left": -(boxClientWidth/(this.scaleVal))*(1-this.scaleVal)/2
          })

        }
      }
    },
    blurText() {
      let $el = $(this.$refs.area);
      let $boxel = $(this.$refs.areabox);
      console.log($el)
      this.scaleVal = 1;
      $el.css({
        "transform": `scale(${this.scaleVal})`,
        "height":this.type === 'l_t' ? '100%' : 14,
        "width":"100%",
        "position":"relative",
        "top": 0,
        "left":0,
      })
      let areaScrollHeight = $el[0].scrollHeight;
      let areaClientHeight = $el[0].clientHeight;
      let boxClientHeight = $boxel[0].clientHeight;
      if(areaScrollHeight <= boxClientHeight){
        let textIsOneLine = areaScrollHeight < 20;
        $el.css({
          "height": areaScrollHeight,
          "text-align":(this.type === 'c_c' && textIsOneLine) ? 'center' : 'left'
        })
        $boxel.css({
          "display":"flex",
          "align-items":"center"
        })
      }else {
        $el.css({
          "height": "100%",
          "text-align":"left"
        })
        this.recurScale();

        if(this.type === 'l_c' || this.type === 'c_c'){
          $el.css({
            "height": 10
          })
          $el.css({
            "height": $el[0].scrollHeight,
            "top": -(boxClientHeight/(this.scaleVal))*(1-this.scaleVal)/2 + (boxClientHeight - $el[0].scrollHeight*this.scaleVal)/(2*this.scaleVal),
            // "left":-(boxClientWidth/(this.scaleVal))*(1-this.scaleVal)/2
          })
          console.log("nmd",(boxClientHeight - $el[0].scrollHeight*this.scaleVal)/2)

        }
      }
    },
    recurScale(){
      console.log($(this.$refs.area))
      let $el = $(this.$refs.area);
      let $boxel = $(this.$refs.areabox);
      let areaScrollHeight = $el[0].scrollHeight;
      let areaClientHeight = $el[0].clientHeight;
      let boxClientWidth = $boxel[0].clientWidth;
      let boxClientHeight = $boxel[0].clientHeight;
      if (areaScrollHeight > areaClientHeight && this.scaleVal >= 0.05) {
        this.scaleVal -= 0.05;
        $el.css({
          "transform": `scale(${this.scaleVal})`,
          "height": boxClientHeight/(this.scaleVal),
          "width": boxClientWidth/(this.scaleVal),
          "position":"relative",
          "top": -(boxClientHeight/(this.scaleVal))*(1-this.scaleVal)/2,
          "left":-(boxClientWidth/(this.scaleVal))*(1-this.scaleVal)/2
        })
        this.recurScale();
      }
    }
  }
}
</script>
<style lang="less">
.scale_input{
  .area_box{
    //border: 1px solid black;
    cursor: text;
    overflow: hidden;
    textarea{
      height: 100%;
      width: 100%;
      border: 0;
      resize: none;
      transform: scale(1);
      font-size: 14px;
      font-family: monospace;
      color: #000;
      overflow: hidden;
    }
  }
}
</style>